export const navLinks = [
  {
    label: 'Projects',
    pathname: '/',
    hash: '#project-1',
  },
  {
    label: 'About',
    pathname: '/',
    hash: '#about',
  },
  {
    label: 'Timeline',
    pathname: '/',
    hash: '#details',
  },
  {
    label: 'Contact',
    pathname: '/contact',
  },
];

export const socialLinks = [
  {
    label: 'GitHub',
    url: 'https://github.com/MehdiJarraya',
    icon: 'github',
  },
  {
    label: 'Linkedin',
    url: 'https://www.linkedin.com/in/mehdi-jarraya-b198aba7/',
    icon: 'linkedin',
  },
  {
    label: 'Facebook',
    url: 'https://www.facebook.com/mehdi.jarraya/',
    icon: 'facebook',
  },
];
